import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const LanguagesSection: React.FC = () => {
  const { t } = useLanguage();

  const languages = [
    { name: t('languages.turkish'), level: t('languages.native'), proficiency: 'C2' },
    { name: t('languages.english'), level: t('languages.independent'), proficiency: 'B2' },
    { name: t('languages.russian'), level: t('languages.basic'), proficiency: 'A1' }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-gradient-to-r from-indigo-500/10 via-purple-500/10 to-indigo-500/10 border border-indigo-500/20 p-6 rounded-2xl backdrop-blur-sm"
    >
      <h3 className="text-xl font-semibold text-white mb-4">{t('languages.title')}</h3>
      <div className="space-y-3">
        {languages.map((lang, index) => (
          <div key={lang.name} className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-indigo-400 font-medium">{lang.name}</span>
              <span className="text-gray-400 text-sm">({lang.level})</span>
            </div>
            <span className="bg-indigo-500/20 border border-indigo-500/30 text-indigo-300 px-3 py-1 rounded-full text-sm">
              {lang.proficiency}
            </span>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default LanguagesSection;
